export default __webpack_public_path__ + "static/media/person3.e332a62f.png";